import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForwardCurveComponent } from './forward-curve/forward-curve.component';
import { VolatilitySurfaceComponent } from './volatility-surface/volatility-surface.component';
import { HistoricalGraphComponent } from './historical-graph/historical-graph.component';
import { SharedModule } from '@approot/shared/shared.module';
import { MarketsDetailComponent } from './markets-detail.component';

@NgModule({
  declarations: [
    ForwardCurveComponent,
    VolatilitySurfaceComponent,
    HistoricalGraphComponent,
    MarketsDetailComponent
  ],
  imports: [SharedModule],
  exports: [
    ForwardCurveComponent,
    VolatilitySurfaceComponent,
    HistoricalGraphComponent,
    MarketsDetailComponent
  ]
})
export class MarketsDetailModule {}
